import http from '@/plugins/http'

export default class Settings {
  static async update(employment, settings) {
    return await http.put(`employments/${employment.id}/settings`, settings)
  }
}
